import Glider from 'glider-js';
import debounce from 'lodash.debounce';

// Constants
const CAROUSEL_MAX_WIDTH = 1376;
const TAB_MIN_WIDTH = 200;

// Helper functions
const calculateConstraints = (carouselContainer, carouselSlides) => {
	const tabsCarouselContainerWidth = parseInt(getComputedStyle(carouselContainer).width);
	const tabsSumWidth = carouselSlides.reduce((sumWidth, tabItem) => {
		const tabWidth = parseInt(getComputedStyle(tabItem).width);
		const tabMarginRight = parseInt(getComputedStyle(tabItem).marginRight);
		return sumWidth + (tabWidth > TAB_MIN_WIDTH ? tabWidth : TAB_MIN_WIDTH) + tabMarginRight;
	}, 0);

	return { tabsCarouselContainerWidth, tabsSumWidth };
};

const shouldInitGlider = (tabsCarouselContainerWidth, tabsSumWidth, itemCount) => {
	return (
		tabsCarouselContainerWidth < tabsSumWidth &&
		tabsCarouselContainerWidth < CAROUSEL_MAX_WIDTH &&
		itemCount > 2 &&
		window.innerWidth < 1000
	);
};

const initializedGliders = {};

const initGlider = (index, carouselContainer, { tabsCarouselContainerWidth, tabsSumWidth, itemCount }, { prevControl, nextControl }) => {
	const slidesToShow = (tabsCarouselContainerWidth / tabsSumWidth) * itemCount;
	if (initializedGliders[index]) {
		initializedGliders[index].setOption({
			...initializedGliders[index].opt,
			slidesToShow,
		});
		initializedGliders[index].refresh();
	} else {
		const glider = new Glider(carouselContainer, {
			slidesToShow,
			slidesToScroll: 1,
			draggable: false,
			duration: 0.3,
			arrows: {
				prev: prevControl,
				next: nextControl,
			},
		});
		initializedGliders[index] = glider;
	}
};

// Init component
export const init = () => {
	const jsTabsCarousel = document.querySelectorAll('.js-tabs-carousel');
	Array.from(jsTabsCarousel).forEach((tabsCarousel, index) => {
		let items = Array.from(tabsCarousel.querySelectorAll('.tabs__item'));
		const itemCount = items.length;
		const { tabsCarouselContainerWidth, tabsSumWidth } = calculateConstraints(tabsCarousel, items);

		// Elements
		let prevControl = tabsCarousel.nextElementSibling.querySelector('.tabs__nav__controls__arrow-prev');
		let nextControl = tabsCarousel.nextElementSibling.querySelector('.tabs__nav__controls__arrow-next');
		const tabsNavElem = tabsCarousel.closest('.tabs__nav');
		const tabsListElem = tabsNavElem.querySelector('.tabs__list');
		const gliderControlElem = tabsNavElem.querySelector('.tabs__nav__controls');

		const manageGlider = (initializingGlider, gliderSlidesProps) => {
			const { tabsCarouselContainerWidth, tabsSumWidth, itemCount } = gliderSlidesProps;

			// Destroy glider on big screens
			if (tabsCarouselContainerWidth >= CAROUSEL_MAX_WIDTH && initializedGliders[index]) {
				/* Cannot use original glider destroy() method and reinit because after re-init on small 
				screen the buttons are not working properly. Fixed with inline style change. */
				const glider = tabsCarousel.querySelector('.glider-track');
				if (glider) {
					items.forEach((item) => (item.style.width = 'auto'));
					glider.style.width = '100%';
					glider.style.display = 'flex';
					glider.classList.remove('glider-track');
				}
			}

			if (initializingGlider) {
				tabsListElem.classList.remove('tabs__list--center');
				gliderControlElem.classList.remove('tabs__nav__controls--hide-controls');
				gliderControlElem.classList.add('tabs__nav__controls--show-controls');
				tabsNavElem.classList.add('tabs__nav--glider');
				initGlider(index, tabsCarousel, { tabsCarouselContainerWidth, tabsSumWidth, itemCount }, { prevControl, nextControl });
			}

			if (!initializingGlider) {
				gliderControlElem.classList.remove('tabs__nav__controls--show-controls');
				tabsNavElem.classList.remove('tabs__nav--glider');
				gliderControlElem.classList.add('tabs__nav__controls--hide-controls');
				tabsListElem.classList.add('tabs__list--center');
			}
		};

		// Manage glider on init
		manageGlider(shouldInitGlider(tabsCarouselContainerWidth, tabsSumWidth, itemCount), {
			tabsCarouselContainerWidth,
			tabsSumWidth,
			itemCount,
		});

		// Handlers
		const resizeHandler = () => {
			const { tabsCarouselContainerWidth, tabsSumWidth } = calculateConstraints(tabsCarousel, items);

			// Manage glider on resize
			manageGlider(shouldInitGlider(tabsCarouselContainerWidth, tabsSumWidth, itemCount), {
				tabsCarouselContainerWidth,
				tabsSumWidth,
				itemCount,
			});
		};

		$(window).on('resize', debounce(resizeHandler, 500));
	});
};
